import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profile } = useAuth();

  const roles = profile?.role
    ? Array.isArray(profile.role)
      ? profile.role
      : [profile.role]
    : [];

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="bg-card border border-border rounded-2xl p-10 max-w-md w-full text-center shadow-modal">
        <div className="mb-6">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" className="mx-auto">
            <circle cx="28" cy="28" r="28" className="fill-muted" />
            <path
              d="M28 16a6 6 0 00-6 6v4h-2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V28a2 2 0 00-2-2h-2v-4a6 6 0 00-6-6zm0 2a4 4 0 014 4v4H24v-4a4 4 0 014-4z"
              className="fill-error"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-foreground mb-2">{t('unauthorized.title')}</h1>
        <p className="text-muted-foreground text-base mb-5">
          {t('unauthorized.message')}
        </p>

        {roles.length > 0 && (
          <p className="text-muted-foreground text-sm mb-7">
            {roles.length > 1 ? t('unauthorized.yourRoles') : t('unauthorized.yourRole')} :{" "}
            {roles.map((r) => (
              <span
                key={r}
                className="inline-block bg-muted text-primary rounded-md px-2.5 py-0.5 ml-1 text-xs font-semibold uppercase tracking-wide"
              >
                {r}
              </span>
            ))}
          </p>
        )}

        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-2.5 px-6 rounded-lg text-sm transition-colors"
          >
            {t('unauthorized.goToDashboard')}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="bg-transparent text-muted-foreground border border-border hover:bg-muted py-2.5 px-6 rounded-lg text-sm transition-colors"
          >
            {t('unauthorized.back')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
